export const QUERY_GET_COUNT = /* GraphQL */ `
	query ($key: String!) {
		getCount(key: $key) {
			countValue {
				total
				cid
			}
		}
	}
`;
